import {Injectable} from '@angular/core';
import {FormControl} from '@angular/forms';
import * as moment from 'moment';
import {CALENDAR_LOCALE} from '../constans/calendar-contants';
import {CurrencyPipe} from '@angular/common';
import {EstadosOR} from '../enums/estados-or.enum';
import {Router} from '@angular/router';
import {AuthService} from './auth.service';
import {StorageService} from './storage.service';
import {StorageEnum} from '../enums/storage.enum';

@Injectable()
export class GlobalsService {

    constructor(
        private _currency: CurrencyPipe,
        private router: Router,
        private _authService: AuthService,
        private _storageService: StorageService
    ) { }

    getTitle(){
        let url: string;
        const moduleList = JSON.parse(sessionStorage.getItem('userProfile')).AppModules;
        moduleList.forEach(category => {
            if(category.Description === "Panel de Control" && this.router.url.includes('/dms/panel-control')){
                const menuMock  = JSON.parse(sessionStorage.getItem('optionMenu'));
                url = menuMock.Title;
            }
            category.Childs.find(menu => {
                if(menu.route === this.router.url){
                    url = menu.Title;
                }
            });
        });
        return url;
    }

    getLabel(dataItem: any, field: string) {
        const arrField = field.split(".");
        if (arrField.length > 1) {
            return dataItem[arrField[0]][arrField[1]];
        }
        return dataItem[field];
    }

    fixDecimalsInReactiveForm(control: FormControl, decimals = 2) {
        if (!control || control.value === '' || control.value === null) {
            control.setValue('0', { emitEvent: false });
        }

        if (decimals === 0) {
            control.setValue(Math.round(Number(control.value)).toFixed(decimals), { emitEvent: false });
        } else {
            control.setValue(Number(control.value).toFixed(decimals), { emitEvent: false });
        }
    }

    getHourMinSeg(data) {
        return moment(data).format('HH:mm:ss');
    }

    copiarAlPortapapeles(value: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    getStatusForTranslate(estado: EstadosOR) {
        switch (estado) {

            case EstadosOR.CERRADA:
                return 'labels.cerrado';
            case EstadosOR.PRESUPUESTOENCURSO:
                return 'labels.encurso';
            case EstadosOR.PRESUPUESTOABIERTO:
                return 'labels.encurso';
            case EstadosOR.PRESUPUESTOCERRADO:
                return 'labels.cerrado';
            case EstadosOR.PRESUPUESTOACEPTADO:
                return 'labels.aceptado';
            case EstadosOR.PRESUPUESTO_CiService:
                return 'labels.cis';
            default:
                return 'labels.rechazado';
        }
    }

    getEmailRegex() {
        return /^[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~\-ñÑ]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
    }

    getCalendarLocale() {
        return sessionStorage.getItem('culture') ? CALENDAR_LOCALE[JSON.parse(sessionStorage.getItem('culture'))] : CALENDAR_LOCALE['es'];
    }

    getDateFormatForServer(date) {
        if (moment(date).isValid()) {
            return `/Date(${moment(date).valueOf()})/`;
        }
        return null;
    }

    getDateFormatForServerNoTime(date) {
        if (moment(date).isValid()) {
            return `/Date(${moment(date).startOf('day').utc().valueOf()})/`;
        }
        return null;
    }

    getDateFormatForServerUnix(date) {
        return `/Date(${moment.unix(date).valueOf()})/`;
    }

    getDateFormatWithHourAndMinutes(date, hour: string, minutes: string) {
        return this.getDateFormatForServer(moment(`${this.getDateFormatYMD(date)} ${hour}:${minutes}`).toDate());
    }

    getDate(date: string) {
        return moment(date).toDate();
    }

    getDateFormatted(date: string, format: string): Date {
        return moment(date, format).toDate();
    }

    getFechaATravesDelMes(mes: number) {
        let m = '';
        if (mes < 10) {
            m = '0' + mes;
        } else {
            m = '' + mes;
        }
        return moment(`${moment().year()}-${mes}-01 00:00:00`).toDate();
    }

    getNewDateForResumenPresupuestosTaller(date1, date2) {
        const d1 = this.getDateFormatYMD(date1);
        const d2 = this.getDateFormatHourMinutesSeconds(date2);
        const nd = moment(d1 + ' ' + d2).toDate();
        if (moment(nd).isValid()) {
            return nd;
        } else {
            return null;
        }
    }

    // params = "21/7/2021"
    getStringToDate(params) {
        let parts = params.split('/');
        return new Date(parts[2], parts[1] - 1, parts[0]);
    }

    getDateForGestionHorarios(hour: string) {
        return this.getDateFormatForServer(moment(`1970-01-01 ${hour}:00`).toDate());
    }

    getDateFormatForServer2(date) {
        return `/Date(${moment(date).valueOf()})/`;
    }

    getDateFormatForServerNow() {
        return `/Date(${moment().valueOf()})/`;
    }

    getDateFormatMonthYear(date) {
        return moment(date).format('MM/YYYY');
    }

    getDateFormatComplete(date) {
        return moment(date).format('YYYY-MM-DD HH:mm:ss');
    }

    getDateFormatForCompare(date) {
        return Number(moment(date).format('YYYYMMDD'));
    }

    getDateFormatComplete2(date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss');
    }

    getDateFormatComplete3(date) {
        return moment(date).format('DD/MM/YYYY HH:mm:ss');
    }

    getDateFormatMinutes(date) {
        return moment(date).format('DD/MM/YYYY HH:mm');
    }

    getDateFormatHourMinutesSeconds(date) {
        return moment(date).format('HH:mm:ss');
    }

    getHourMinutes(date) {
        return moment(date).format('HH:mm');
    }

    getMinutes(date) {
        return moment(date).format('mm');
    }

    getHour(date) {
        return moment(date).format('HH');
    }

    getDateFormatStandar(date) {
        return moment(date, 'DD-MMMM-YYYY HH:mm:ss').format('DD/MM/YYYY');
    }

    getYear(date) {
        return moment(date).year();
    }

    getActualYear() {
        return moment().year();
    }

    getCurrentYear() {
        return moment().year();
    }

    getArrOfYears() {
        const max = Number(this.getCurrentYear());
        const min = (max - 30);
        let arrYears: number[] = [];
        for (let i = max; i >= min; i--) {
            arrYears.push(i);
        }
        return arrYears;
    }

    getDateFormat(date) {
        if (moment(date).isValid()) {
            return moment(date).toDate();
        }
        return null;
    }

    getDateFormatMDY(date) {
        return moment(date).format('DD/MM/YYYY');
    }

    getDateFormatYMD(date) {
        return moment(date).format('YYYY-MM-DD');
    }

    getDateFormatDMYHm(date) {
        return moment(date).format('DD/MM/YYYY HH:mm')
    }

    getDateFormatToday() {
        return moment().toDate();
    }

    getDateFormatTodayDMY() {
        return moment().format('D/M/YYYY');
    }

    getDateFormatTodayDMYHHmm() {
        return moment().format('D/M/YYYY HH:mm');
    }

    // dateString: "01/09/2021 00:00:00"
    addHHMMToDate(dateString) {
        let dateToday = this.getDateFormatTodayDMYHHmm();
        let datedWithHoursAndMinutesToday = `${dateString.split(" ")[0]} ${dateToday.split(" ")[1]}`;
        let dateFomat = this.getDateToStringComplete(datedWithHoursAndMinutesToday);
        let dateFinal = this.getDateFormatForServer(dateFomat);
        return dateFinal;
    }

    mas12() {
        const fechaActual = moment().add(12, 'year').toDate();
        return fechaActual;
    }

    mas12conFecha(date) {
        return moment(date).add(12, 'year').toDate();
    }

    // Return true is if a date
    checkIfIsADate(date) {
        return moment(date, moment.ISO_8601, true).isValid();
    }

    //Esta semana / mes / año  'week'/ 'month' / 'year'
    getThisweek(date, that) {
        if (that === 'ini') {
            return moment().startOf(date).toDate();
        } else {
            return moment().endOf(date).toDate();
        }
    }

    //última semana / mes / año  'weeks'/ 'months' / 'years'
    getLastWeek(that) {
        if (that === 'ini') {
            return moment().subtract(1, 'weeks').startOf('week').toDate();
        } else {
            return moment().subtract(1, 'weeks').endOf('week').toDate();
        }
    }

    //Semana pasada  / mes / año  'weeks'/ 'months' / 'years'
    getPast(dates, date, that) {
        if (that === 'ini') {
            return moment().subtract(1, dates).startOf(date).toDate();
        } else {
            return moment().subtract(1, dates).endOf(date).toDate();
        }
    }

    getLastMonths(that) {
        const mesActual = moment().get('month');
        if (that === 'ini') {
            return moment().month(mesActual).startOf('month').toDate();
        } else {
            return moment().month(mesActual).endOf('month').toDate();
        }
    }

    //Para obtener el día de ayer en una variable
    getYesterday() {
        //  return moment().subtract(1, 'days').calendar();
        return moment().subtract(1, 'd').format('DD/MM/YYYY');
    }

    //Para obtener el día de ayer en una variable
    getYesterdaytoDate() {
        return moment().subtract(1, 'd').toDate();
    }

    //El parámetro que se le pasa es el número de días que hay que restar al día de hoy
    //por ejemplo si queremos obtener la última semana se le pasaría un 7
    lastDays(howMany) {
        return moment().subtract(howMany, 'd').format('DD/MM/YYYY');
    }

    //El parámetro que se le pasa es el número de días que hay que restar al día de hoy
    //por ejemplo si queremos obtener la última semana se le pasaría un 7
    lastDaystoDate(howMany) {
        return moment().subtract(howMany, 'd').toDate();
    }

    getDayMonthYear() {
        return moment().format('DD/MM/YYYY');
    }

    getLastYear(that) {
        const ultimoAnno = (moment().year() - 1).toString();

        if (that === 'ini') {
            return moment(ultimoAnno).month(0).startOf('month').toDate();
        } else {
            return moment(ultimoAnno).month(11).endOf('month').toDate();
        }

    }

    getThis3month(that) {

        if (that === 'ini') {
            return moment().quarter(moment().quarter()).startOf('quarter').toDate();
        } else {
            return moment().quarter(moment().quarter()).endOf('quarter').toDate();
        }
    }
    getThis6month(that) {
        const mesActual = moment().get('month') + 1;
        const semestreActual = Math.ceil(mesActual / 6);
        if (semestreActual === 1) {
            if (that === 'ini') {
                return moment().date(1).month(0).toDate();
            } else {
                return moment().month(5).endOf('month').toDate();
            }
        } else {
            if (that === 'ini') {
                return moment().date(1).month(6).toDate();
            } else {
                return moment().month(11).endOf('month').toDate();
            }
        }
    }

    getlast3month(that) {
        if (that === 'ini') {
            return moment().month(9).startOf('month').toDate();
        } else {
            return moment().month(11).endOf('month').toDate();
        }
    }

    getlast6month(that) {
        const mesActual = moment().get('month') + 1;
        const semestreActual = Math.ceil(mesActual / 6);
        if (semestreActual === 1) {
            if (that === 'ini') {
                return moment().month(0).startOf('month').toDate();
            } else {
                return moment().month(5).endOf('month').toDate();
            }
        } else {
            if (that === 'ini') {
                return moment().month(6).startOf('month').toDate();
            } else {
                return moment().month(11).endOf('month').toDate();
            }
        }
    }

    getPast3month(that) {
        const mesActual = moment().get('month') + 1;
        const trimestreActual = Math.ceil(mesActual / 3);
        const mesInicioTrimestre = (trimestreActual - 1) * 3;
        if (that === 'ini') {
            return moment().set('month', mesInicioTrimestre).subtract(3, 'months').startOf('month').toDate();
        } else {
            return moment().set('month', mesInicioTrimestre).subtract(1, 'months').endOf('month').toDate();
        }
    }

    getPast6month(that) {
        const mesActual = moment().get('month') + 1;
        const trimestreActual = Math.ceil(mesActual / 6);
        const mesInicioTrimestre = (trimestreActual - 1) * 6;
        if (that === 'ini') {
            return moment().set('month', mesInicioTrimestre).subtract(6, 'months').startOf('month').toDate();
        } else {
            return moment().set('month', mesInicioTrimestre).subtract(1, 'months').endOf('month').toDate();
        }
    }

    getDateToString(dateString) {
        return moment(dateString, 'DD/MM/YYYY').toDate();
    }

    getDateToStringComplete(dateString) {
        return moment(dateString, 'DD/MM/YYYY HH:mm:ss').toDate();
    }

    getFormatCurrency(item: number): string {
        return this._currency.transform(item, 'EUR', 'symbol', '1.2-2');
    }

    // Sat Dec 31 2022 00:00:00 GMT+0100 (hora estándar de Europa central)
    compareDates(date1, date2) {
        let changed = false;
        if (date1.getTime() !== date2.getTime()) {
            changed = true;
        }
        return changed;
    }

    // Sumar días a la fecha
    addDays(date, howMany) {
        return moment(date).add(howMany, 'd').toDate();
    }

    // Pone la hora al inicio del día o al final del día
    getResetHours(date, that) {
        if (that === 'ini') {
            return moment(date).startOf('d').toDate();
        } else {
            return moment(date).endOf('d').toDate();
        }
    }

    // The startDate can't be bigger than endDate
    compareDateStartWithDateEnd(startDate, endDate) {
        let errorDate = false;
        if (startDate.getTime() > endDate.getTime()) {
            errorDate = true;
        }
        return errorDate;
    }

    // diferencia entre fechas en la unidad indicada (days, hours...)
    getDiffDates(date1, date2, unidad) {
        return moment(date1).diff(moment(date2), unidad);
    }

    getActiveWareHouseNumber() {

        let warehouseNumber;
        if (sessionStorage.getItem('userProfile')) {
            let userProfile = JSON.parse(sessionStorage.getItem('userProfile'));

            if (userProfile.ActiveWareHouseNumber) {
                warehouseNumber = JSON.parse(userProfile.ActiveWareHouseNumber);
            }

        }

        return warehouseNumber;


    }

    getTicketBaiStatus() {
        return JSON.parse(sessionStorage.getItem('userProfile')).Company.TicketBAIEnabled;
    }

    getBatuzEnabled(): boolean {
        return JSON.parse(sessionStorage.getItem('userProfile')).Company.BatuzEnabled;
    }

    isMarcaBlanca() {
        return JSON.parse(sessionStorage.getItem('userProfile')).Company.BrandCode === 'ST';
    }

    checkIfStringWithDecimalsToFixedTwoDecimals(value) {
        if (value !== null && value !== undefined && value !== '') {
            if (value.indexOf('.') !== -1) {
                if (value.split('.')[1].length > 2) {
                    value = Number.parseFloat(value).toFixed(2);
                }
            }
        }
        return value;
    }

    checkIfStringWithDecimals(value) {
        if (value !== null && value !== undefined && value !== '') {
            if (value.indexOf('.') !== -1) {
                if (value.split('.')[1].length > 2) {
                    return true
                }
            }
        }
        return false;
    }

    getDefaultPageSize(): number {
        const pageSize = JSON.parse(sessionStorage.getItem('AplicationType')).DefaultPageSize;
        return pageSize ? pageSize : 20;
    }

    getPageSizeList(): number[] {
        const pageSizeList = JSON.parse(sessionStorage.getItem('AplicationType')).PageSizeList;
        return pageSizeList ? pageSizeList : [20, 30, 40]
    }

    getDateMilisegunds(): { now, b3m } {
        // 3 meses 7889250000
        const desde = new Date().getTime() - 7889250000;
        return {
            now: new Date().getTime(),
            b3m: desde,
        };
    }
}
